import {
  Breadcrumb,
  BreadcrumbItem,
  PageBreadcrumb,
  PageSection,
  PageSectionVariants,
  Content,
  Icon,
  ContentVariants,
  List,
  ListItem,
} from '@patternfly/react-core';
import { ClusterIcon } from '@patternfly/react-icons';
import React from 'react';

function Privacy() {
  // @ts-ignore
  return (
    <>
      <PageBreadcrumb hasBodyWrapper={false} hasShadowBottom={false}>
        <Breadcrumb ouiaId="BasicBreadcrumb">
          <BreadcrumbItem isActive>Terms of Services</BreadcrumbItem>
        </Breadcrumb>
      </PageBreadcrumb>
      <PageSection hasBodyWrapper variant={PageSectionVariants.default} isWidthLimited hasShadowBottom={true}>
        <Content component="h1">
          <Icon size="lg" style={{ marginRight: '8px' }}>
            <ClusterIcon />
          </Icon>
          Terms of Service
        </Content>
      </PageSection>

      <PageSection hasBodyWrapper={true} variant={PageSectionVariants.default}>
        <Content isEditorial>
          <h2>Terms of Service</h2>

          <h3>1. Introduction</h3>
          <p>
            These Terms of Service ("Terms") govern your access and use of the infrastructure management services
            ("Services") provided by Italique SRL - Ancalagon ("we," "us," or "our"). By accessing or using our
            Services, you agree to be bound by these Terms.
          </p>

          <h2>2. Service Description</h2>
          <p>We provide IT infrastructure hosting and management services, including but not limited to:</p>
          <List>
            <ListItem>Cloud infrastructure hosting and management</ListItem>
            <ListItem>Server monitoring and maintenance</ListItem>
            <ListItem>System security management</ListItem>
            <ListItem>Backup and disaster recovery services</ListItem>
            <ListItem>Technical support and troubleshooting</ListItem>
            <ListItem>Resource allocation and scaling</ListItem>
          </List>

          <h2>3. User Accounts</h2>
          <p>To access the Services, you must:</p>
          <List>
            <ListItem>Create an account with accurate, complete information</ListItem>
            <ListItem>Maintain the security of your account credentials</ListItem>
            <ListItem>Promptly notify us of any unauthorized access</ListItem>
            <ListItem>Be responsible for all activities under your account</ListItem>
          </List>

          <h2>4. Client Responsibilities</h2>
          <p>You agree to:</p>
          <List>
            <ListItem>Provide accurate and complete information about your infrastructure needs</ListItem>
            <ListItem>Maintain appropriate security measures for your own systems and data</ListItem>
            <ListItem>Comply with all applicable laws and regulations</ListItem>
            <ListItem>Use the Services in accordance with acceptable use policies</ListItem>
            <ListItem>Maintain current contact and billing information</ListItem>
          </List>

          <h2>5. Service Level Agreement (SLA)</h2>
          <p>Our service commitment includes:</p>
          <List>
            <ListItem>99.9% uptime guarantee for hosted infrastructure</ListItem>
            <ListItem>Response time within 1 hour for critical issues</ListItem>
            <ListItem>Regular system maintenance and updates</ListItem>
            <ListItem>24/7 monitoring and alert systems</ListItem>
            <ListItem>Monthly performance reports</ListItem>
          </List>

          <h2>6. Fees and Payment</h2>
          <p>Payment terms include:</p>
          <List>
            <ListItem>Monthly or annual billing options</ListItem>
            <ListItem>Payment due within 30 days of invoice date</ListItem>
            <ListItem>Late payments subject to 1.5% monthly interest</ListItem>
            <ListItem>Service suspension for accounts 60 days past due</ListItem>
            <ListItem>All fees are non-refundable unless otherwise specified</ListItem>
          </List>

          <h2>7. Data Security and Privacy</h2>
          <p>We commit to:</p>
          <List>
            <ListItem>Implementing industry-standard security measures</ListItem>
            <ListItem>Maintaining confidentiality of client data</ListItem>
            <ListItem>Regular security audits and updates</ListItem>
            <ListItem>Prompt notification of security incidents</ListItem>
            <ListItem>Compliance with applicable data protection laws</ListItem>
          </List>

          <h2>8. Acceptable Use</h2>
          <p>You agree not to:</p>
          <List>
            <ListItem>Use the Services for illegal purposes</ListItem>
            <ListItem>Attempt to breach or circumvent security measures</ListItem>
            <ListItem>Transmit malicious code or conduct denial of service attacks</ListItem>
            <ListItem>Exceed authorized access levels or resource limits</ListItem>
            <ListItem>Resell or redistribute the Services without authorization</ListItem>
          </List>

          <h2>9. Term and Termination</h2>
          <p>Terms regarding service duration and termination:</p>
          <List>
            <ListItem>Initial term of 12 months unless otherwise specified</ListItem>
            <ListItem>30-day written notice required for termination</ListItem>
            <ListItem>Immediate termination for breach of terms</ListItem>
            <ListItem>Data preservation for 30 days post-termination</ListItem>
            <ListItem>Pro-rated refunds for prepaid services</ListItem>
          </List>

          <h2>10. Limitation of Liability</h2>
          <p>Our liability is limited to:</p>
          <List>
            <ListItem>The amount paid for services in the previous 12 months</ListItem>
            <ListItem>Exclusion of indirect or consequential damages</ListItem>
            <ListItem>No liability for force majeure events</ListItem>
            <ListItem>No warranty for third-party services or software</ListItem>
          </List>

          <h2>11. Indemnification</h2>
          <p>You agree to indemnify us against claims arising from:</p>
          <List>
            <ListItem>Violation of these Terms</ListItem>
            <ListItem>Unauthorized use of the Services</ListItem>
            <ListItem>Violation of applicable laws</ListItem>
            <ListItem>Infringement of third-party rights</ListItem>
          </List>

          <h2>12. Modifications to Services</h2>
          <p>We reserve the right to:</p>
          <List>
            <ListItem>Modify or discontinue features with notice</ListItem>
            <ListItem>Update these Terms as needed</ListItem>
            <ListItem>Adjust pricing with 30 days notice</ListItem>
            <ListItem>Implement new security measures</ListItem>
          </List>

          <h2>13. Governing Law</h2>
          <p>
            These Terms are governed by and construed in accordance with the laws of Belgium. Any disputes shall be
            resolved in the courts of Liège, Belgium.
          </p>

          <h2>14. Contact Information</h2>
          <p>For questions about these Terms, contact us at:</p>
          <p>Email: legal@ancalagon.be</p>
          <p>Phone: +32 483 09 91 29</p>
          <p>Address: Rue Jules Stiernet 88 - 4252 OMAL - BE</p>

          <p>Last updated: [Current Date]</p>
        </Content>
      </PageSection>
    </>
  );
}

export default Privacy;
